import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { User } from 'src/app/models/user.model';
import { ApiUxService } from 'src/app/shared/api-ux/api-ux.service';
import { ApiUxInitService } from '../init/api-ux-init.service';

@Injectable({
  providedIn: 'root',
})
export class UserService extends ApiUxInitService<User> {
  constructor(apiUxService: ApiUxService) {
    super(apiUxService, 'user');
  }

  isPasswordValid(password: string): Observable<boolean> {
    return this.apiUxService.post<boolean>('user/is-password-valid', { plainPassword: password }).pipe(
      tap(r => {
        this.data.isAuthVerified = r;
      })
    );
  }

  isCodeValid(code: string): Observable<boolean> {
    return this.apiUxService.post<boolean>('user/is-code-valid', {
      code,
    });
  }

  updatePassword(code: string, password: string): Observable<boolean> {
    return this.apiUxService.post<boolean>('user/password', {
      code,
      password,
    });
  }

  requestNewCode(): Observable<boolean> {
    return this.apiUxService.get<boolean>('user/new-code');
  }
}
